import React, { useState, useEffect } from "react";
import { useFirestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { useSelector, connect } from "react-redux";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import { Link } from "react-router-dom";
import {
  USER_DRIVERS_PATH,
  USER_GENERAL_PATH,
  USER_ORDERS_PATH,
} from "../../../constants/paths";

import OrderPreview from "../../../components/orders/OrderPreview";
import { generateReport } from "../../../store/actions/RestaurantActions";
import ModalReport from "../../../components/forms/ModalReport";

import Sound from "react-sound";

const MyRestaurantPage = ({ generateReport }) => {
  const [restaurantId, setRestaurantId] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [currentLength, setCurrentLength] = useState(0);
  const [playingSound, setPlayingSound] = useState(Sound.status.STOPPED);

  var subtitle;

  const uid = useSelector(({ firebase }) => firebase.auth.uid);

  useFirestoreConnect([
    { collection: "restaurants", where: [["user_id", "==", uid]] },
    {
      collection: "restaurants",
      doc: restaurantId || "nothing",
      subcollections: [
        { collection: "orders", limit: 5, orderBy: [["dateCreated", "desc"]] },
      ],
      storeAs: `recent-orders`,
    },
  ]);

  const restaurant = useSelector(({ firestore }) =>
    firestore.ordered.restaurants ? firestore.ordered.restaurants[0] : {}
  );

  const recentOrders = useSelector(
    ({ firestore }) => firestore.ordered["recent-orders"]
  );

  useEffect(() => {
    if (isLoaded(restaurant)) setRestaurantId(restaurant.id);
  }, [restaurant]);

  useEffect(() => {
    if (isLoaded(recentOrders) && !isEmpty(recentOrders)) {
      if (!firstLoad) {
        setCurrentLength(recentOrders.length);
        return setFirstLoad(true);
      } else if (currentLength !== recentOrders.length) {
        setCurrentLength(recentOrders.length);
        return setPlayingSound(Sound.status.PLAYING);
      }
    }
  }, [recentOrders]);

  if (!isLoaded(restaurant)) return <LoadingIndicator></LoadingIndicator>;

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSongFinishedPlaying = () => {
    setPlayingSound(Sound.status.STOPPED);
  };

  return (
    <div className="px-16 py-8 text-gray-900">
      <Sound
        url="https://firebasestorage.googleapis.com/v0/b/supercerca-inowu.appspot.com/o/iphone_5s_alarm.mp3?alt=media&token=d7c74dc2-db7f-44ef-af01-d90ce4af1348"
        playStatus={playingSound}
        playFromPosition={0}
        onFinishedPlaying={handleSongFinishedPlaying}
      />
      <h3 className="text-2xl font-bold">{restaurant.title}</h3>
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b flex justify-between">
          Órdenes recientes
        </p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          {isLoaded(recentOrders) &&
            recentOrders.map((order) => {
              return <OrderPreview {...order}></OrderPreview>;
            })}
        </div>
        <div
          to={USER_ORDERS_PATH}
          className="flex justify-end px-6 py-3 border-t border-gray-300"
        >
          <Link
            to={USER_ORDERS_PATH}
            className="text-sm text-gray-700 font-bold inline-block"
          >
            Todas las órdenes
          </Link>
        </div>
      </div>
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Acciones</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="mb-2">
            <Link className="font-semibold" to={USER_GENERAL_PATH}>
              General
            </Link>
            <p className="text-sm">Editar datos generales</p>
          </div>
          <div className="mb-2">
            <Link className="font-semibold" to={USER_DRIVERS_PATH}>
              Manejar repartidores
            </Link>
            <p className="text-sm">Editar datos de repartidores </p>
          </div>
          <div className="mb-2">
            <a
              href="#"
              className="font-semibold"
              onClick={() => {
                openModal();
              }}
            >
              Generar reporte
            </a>
            <ModalReport
              message="Selecciona las fechas para generar el reporte de órdenes."
              closeModal={closeModal}
              modalIsOpen={modalIsOpen}
              onSubmit={(values) => {
                generateReport(restaurantId, values.startDate, values.endDate);
              }}
              shouldCloseOnEsc
              shouldCloseOnOverlayClick
              subtitle={subtitle}
              title="Generar reportes"
            ></ModalReport>
            <p className="text-sm">
              Generar un reporte de órdenes basado en las fechas seleccionadas
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    generateReport: (restaurantId, startDate, endDate) =>
      dispatch(generateReport(restaurantId, startDate, endDate)),
  };
};

export default connect(null, mapDispatchToProps)(MyRestaurantPage);
